import { useSSRData } from 'hooks';
import { isSalePeriod } from 'utils';
import getFirstCorrectData from './utils';

const useSalePeriod = () => {
    const state = useSSRData();
    // eslint-disable-next-line camelcase
    return getFirstCorrectData(state?.is_sales_period, isSalePeriod(), false);
};

export default useSalePeriod;
